import classNames from 'classnames';
import { Link } from 'gatsby';
import React, { useState } from 'react';

export const Description: React.FC<{
  variant: Queries.VariantPageQuery['variant'];
}> = ({ variant }) => {
  const [expanded, setExpanded] = useState(false);

  if (!variant.airtable.product.description) {
    return null;
  }

  return (
    <>
      {variant.product?.relatedArticle?.__typename ===
        'ContentfulPageDesigner' && (
        <p className="mb-1 text-base font-bold">
          Design by{' '}
          <Link
            to={variant.product.relatedArticle.slug}
            className="link-primary"
          >
            {variant.airtable.product.designer}
          </Link>
        </p>
      )}

      <p
        className={classNames(
          'mx-auto mb-1 max-w-prose text-pretty text-base text-black-600 md:mx-0',
          {
            'line-clamp-3': !expanded,
          },
        )}
      >
        {variant.airtable.product.description}
      </p>

      <button
        className="link-primary mb-4"
        onClick={() => setExpanded(!expanded)}
      >
        Read {expanded ? 'less' : 'more'}
      </button>
    </>
  );
};
